"use client"

import {useAppDispatch} from "@/store";
import {setValidations} from "@/store/slices/globaleSlice";
import {signOut} from "next-auth/react";
import {myLinks} from "@/lib/routes/myLinks";
import {useNotification} from "@/lib/hook/useNotification";
import {useTranslations} from "next-intl";

export const useResponseValidate = () => {
    const dispatch = useAppDispatch()
    const send = useNotification()
    const t = useTranslations('validation');

    const successValidate = (resp, formName) =>{
        if (resp && resp.message) {
            send({
                type: resp.type ? 'error' : 'success',
                description: typeof resp.message==='string' ?
                    t(resp.message) : Object.values(t(resp.message)).join(', ')
            })

        }
        if (resp && resp.status === false && resp.message) {
            dispatch(setValidations({
                errors: resp.message,
                formName
            }))
        }
    }

    const errorValidate = (error, formName) =>{
        if (error && error.response){
            switch (error.response.status){
                case 401:
                    // signOut({callbackUrl: myLinks.getUlr('sign-in')})
                    break
                case 403:
                    send({
                        type: 'error',
                        description: t('access_denied'),
                    })
                    break
                case 404:
                    //dispatch(setErrorMessage('URL не найден'))
                    break
                case 422:
                    if (error.response.data.errors) {
                        const translatedErrors = Object.fromEntries(
                            Object.entries(error.response.data.errors).map(([field, messages]) => [
                                field,
                                messages.map(msg => t(msg))
                            ])
                        )

                        dispatch(setValidations({
                            errors: translatedErrors,
                            formName
                        }))
                    }

                    let resp = `${t('incorrect')} <br/>`;
                    {Object?.values(error.response.data.errors).forEach((errors)=>{
                        if (Array.isArray(errors)){
                            errors.forEach((item)=>{
                                resp += `${t(item)} <br/>`
                            })
                        }else {
                            resp += `${errors} <br/>`
                        }
                    })}
                    send({
                        type: 'error',
                        description: <div dangerouslySetInnerHTML={{ __html: resp }} />,
                    })
                    break
                default:
                    if (error.response.data.message){
                        send({
                            type: 'error',
                            description: error.response.data.message,
                        })
                    }
            }
        }else {
            // signOut()
            // router.push('/500')
        }
    }

    return {
        successValidate,
        errorValidate
    };
}